<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Склад</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/storage1.jpg" width="150" height="106" /> <img src="//iwstatic.g.bsrv.su/resources/images/storage5.jpg" width="150" height="106" />
		</p>
		<p><b>Склад</b> - в этом строении хранятся ресурсы острова, вещи и предметы героя. Вещи в магазин для продажи также выставляются со склада. Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisSklad',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>